import TeamMemberCard from "@/components/frontend/team/TeamCard";
import { teamMembers } from "@/app/(site)/data/dataMembers";
import { revealOnScroll } from "@/lib/animations/gsap";
import { useEffect } from "react";

export default function TeamMembers() {

    useEffect(() => {
        revealOnScroll(".team-card", {
            y: 80,
            duration: 0.5,
            delayBetween: 0.3,
            start: "top 85%",
        });
    }, []);

    return (
        <div className="flex flex-col items-start justify-start bg-gray-200 w-full pb-30">

            <div className="flex flex-col items-start justify-start w-full">

                {/* members grid */}
                <div className="w-full px-4 md:px-10 lg:px-20">
                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
                        {teamMembers.map((member) => (
                            <div key={member.slug} className="team-card">
                                <TeamMemberCard
                                    name={member.name}
                                    position={member.title}
                                    office={member.location}
                                    imageUrl={member.photo}
                                    profileUrl={`/team/${member.slug}`} 
                                />
                            </div>
                        ))}
                    </div>
                </div>

            </div>

        </div>
    );
}
